import { defineStyleConfig } from '@chakra-ui/react';
import fontSizes from '@theme/foundations/fontSizes';
export const Heading = defineStyleConfig({
    baseStyle: {
        color: 'neutral.900',
        fontFamily: 'var(--cb-title-text--font-family)',
        fontWeight: 600,
        letterSpacing: 0,
        margin: 0,
        textAlign: 'left',
        textTransform: 'none',
    },
    defaultProps: {
        size: 'lg',
    },
    sizes: {
        '2xl': {
            fontSize: fontSizes['2xl'],
        },
        '3xl': {
            fontSize: fontSizes['3xl'],
        },
        '4xl': {
            fontSize: fontSizes['4xl'],
        },
        '5xl': {
            fontSize: fontSizes['5xl'],
        },
        '6xl': {
            fontSize: fontSizes['6xl'],
        },
        lg: {
            fontSize: fontSizes.lg,
        },
        md: {
            fontSize: fontSizes.md,
        },
        sm: {
            fontSize: fontSizes.sm,
        },
        xl: {
            fontSize: fontSizes.xl,
        },
        xs: {
            fontSize: fontSizes.xs,
        },
    },
});
